import { render, staticRenderFns } from "./StudentFiles.vue?vue&type=template&id=7eed3b36"
import script from "./StudentFiles.vue?vue&type=script&lang=js"
export * from "./StudentFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports